import axios from "axios";

import base_uri from "../../api/base_url";

export const login = (data) => {
  return axios({
    method: "post",
    url: `${base_uri.api_url}/admin-auth/login`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  });
};

// export const edit_user = (id, data) => {
//   const token = localStorage.getItem("auth_token_travel");
//   return axios({
//     method: "patch",
//     url: `${base_uri.api_url}/updateUser/${id}`,
//     headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
//     data: data,
//   });
// };

export const edit_user = (id, data) => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "patch",
    url: `${base_uri.api_url}/user-registry/updateUser/${id}`,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
    data: data,
  });
};

export const forgot = (data) => {
  return axios({
    method: "post",
    url: `${base_uri.api_url}/admin-auth/forgot-password`,
    data: data,
  });
};

export const verify_otp = (data) => {
  return axios({
    method: "post",
    url: `${base_uri.api_url}/admin-auth/forgot-password-otp-verification`,
    headers: {
      "Content-Type": "application/json",
    },
    data,
  });
};

export const reset_pass = (data) => {
  return axios({
    method: "post",
    url: `${base_uri.api_url}/admin-auth/reset-password`,
    headers: {
      "Content-Type": "application/json",
    },
    data,
  });
};

export const get_Admin_profile = () => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "get",
    url: `${base_uri.api_url}/admin-auth`,
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const edit_profile = (data) => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "patch",
    url: `${base_uri.api_url}/admin-auth/update-profile`,
    headers: { Authorization: `Bearer ${token}` },
    data: data,
  });
};

export const getJourneyDetails = () => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "get",
    url: `${base_uri.api_url}/journey/admin`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getAllUser = () => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "get",
    url: `${base_uri.api_url}/user-registry/getAllUser`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getTagDetails = () => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "get",
    url: `${base_uri.api_url}/tags`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const CreatePlaces = (data) => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "post",
    url: `${base_uri.api_url}/place`,

    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
    data: data,
  });
};

export const delete_place = (id) => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "delete",
    url: `${base_uri.api_url}/place/${id}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const delete_user = (id) => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "delete",
    url: `${base_uri.api_url}/admin-auth/delete-user/${id}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const change_pass = (data) => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "post",
    url: `${base_uri.api_url}/admin-auth/changePassword`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: data,
  });
};

export const get_journey_data = (id) => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "get",
    url: `${base_uri.api_url}/place/${id}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getAlltag = () => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "get",
    url: `${base_uri.api_url}/tags`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const AddTag = (data) => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "post",
    url: `${base_uri.api_url}/tags`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: data,
  });
};
export const delete_tag = (id) => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "delete",
    url: `${base_uri.api_url}/tags/${id}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};
export const update_tag = (id, data) => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "patch",
    url: `${base_uri.api_url}/tags/${id}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: data,
  });
};
export const getAllAppContent = () => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "get",
    url: `${base_uri.api_url}/appContent`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getPublicAppContent = () => {
  return axios({
    method: "get",
    url: `${base_uri.api_url}/appContent`,
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const update_App_Content = (id, data) => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "patch",
    url: `${base_uri.api_url}/appContent/${id}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: data,
  });
};

export const update_place_byId = (id, data) => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "patch",
    url: `${base_uri.api_url}/place/${id}`,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
    data: data,
  });
};

export const delete_place_image = (PlaceId, ImageId, deletefor) => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "delete",
    url: `${base_uri.api_url}/place/placesId/${PlaceId}/galleryimage/${ImageId}/${deletefor}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getAllQuery = () => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "get",
    url: `${base_uri.api_url}/helpCenter/getAllQuery`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const delete_query = (id) => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "delete",
    url: `${base_uri.api_url}/helpCenter/${id}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getAllUplodedImage = () => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "get",
    url: `${base_uri.api_url}/gallery`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteUploadedimage = (id) => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "delete",
    url: `${base_uri.api_url}/gallery/${id}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getTotalUser = () => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "get",
    url: `${base_uri.api_url}/admin-auth/totaluser`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getTotalPlaces = () => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "get",
    url: `${base_uri.api_url}/place/totalPlaces`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getEmailHelpCenter = () => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "get",
    url: `${base_uri.api_url}/contactUs/getemail`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updateEmailHelpCenter = (id, data) => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "patch",
    url: `${base_uri.api_url}/contactUs/${id}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: data,
  });
};

export const getPlaceByid = (id) => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "get",
    url: `${base_uri.api_url}/place/getplacebyid/${id}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getAllRatingAndReview = () => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "get",
    url: `${base_uri.api_url}/ratings`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteRatingAndReview = (id) => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "delete",
    url: `${base_uri.api_url}/ratings/${id}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getAllJourney = () => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "get",
    url: `${base_uri.api_url}/journey/admin`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updateJourneyData = (id, data) => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "patch",
    url: `${base_uri.api_url}/journey/${id}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: data,
  });
};

export const AddJourney = (data) => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "post",
    url: `${base_uri.api_url}/journey`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: data,
  });
};

export const getAllPlaces = () => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "get",
    url: `${base_uri.api_url}/place/getAllPlaces`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updateTagStatus = (id, data) => {
  const token = localStorage.getItem("auth_token_travel");
  return axios({
    method: "patch",
    url: `${base_uri.api_url}/tags/status/${id}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: data,
  });
};
